export default __webpack_public_path__ + "static/media/password-manager-4.dc2e3da4.png";